/**
 * Dialogs for scheduled updates
 *
 * @author Ryan Zhang (rzhang@yext.com)
 */
goog.provide('yext.scheduledupdates.dialog.NewDateDialog');
goog.provide('yext.scheduledupdates.dialog.OverrideUpdateDialog');
goog.provide('yext.scheduledupdates.dialog.ActionResultDialog');
goog.provide('yext.scheduledupdates.dialog.UpdateDatesDialog');
goog.provide('yext.scheduledupdates.dialog.Base');

goog.require('yext');
goog.require('yext.scheduledupdates.DatePicker');

/**
 * Creates a new dialog for scheduling a new update and displays it
 *
 * @constructor
 * @param {DialogOptions} options
 */
yext.scheduledupdates.dialog.NewDateDialog = function(options) {
  if (!options.container) {
    options.container = $('.js-schedule-new-update-dialog');
  }
  var $submit = options.container.find('.js-submit-btn');
  options.title = yext.msg('Schedule a New Update');

  var datepicker = new yext.scheduledupdates.DatePicker(
    options.container.find('.datepicker-input'),
    $submit,
    {minDate: 1},
    function(inputDate) {
      return inputDate >= new Date();
    });

  options.getSubmitData = function() {
    return datepicker.parseDate();
  };

  return new yext.scheduledupdates.dialog.Base(options);
};

/**
 * Dialog for override confirmation
 *
 * @constructor
 * @param {function()} onSubmit Function to run when submit button is clicked
 */
yext.scheduledupdates.dialog.OverrideUpdateDialog = function(onSubmit) {
  var options = {
    container: $('#override-updates-dialog'),
    title: yext.msg('Override Scheduled Updates'),
    unbindOnClose: true,
  };

  options.container.on('submit', onSubmit);

  new yext.scheduledupdates.dialog.Base(options).show();
};

/**
 * Dialog that shows scheduled updates by date. Displays on pill view.
 *
 * @constructor
 * @param {DialogOptions} options
 */
yext.scheduledupdates.dialog.UpdateDatesDialog = function(e) {
  var $element = $(e.target);
  var data = $element.data('jsondata');
  var dates = JSON.parse(data['dates']);
  var template = $('#view-scheduled-updates-date-dialog').html();
  var anchors = getAnchors(
    $('#view-scheduled-updates-date-template').html(),
    dates,
    data['isbulk'],
  );
  template = template.replace('{{scheduledUpdateDateAnchors}}', $.makeArray(anchors).join(''));
  template = template.replace('{{scheduledUpdate}}', getI18nViewText(dates.length));
  var options = {};
  options.container = $(template);
  options.title = yext.msg('Scheduled Updates: {0}', data['fieldname']);
  options.destroyOnClose = true;
  return new yext.scheduledupdates.dialog.Base(options);
};

/**
 * @typedef DialogOptions
 * @type Object
 * @property {string} title The title of the dialog
 * @property {!jQuery} container The selected ui element
 */
/**
 * The base dialog constructor which creates the dialog with the given options,
 * binds actions to it, and displays it
 *
 * @constructor
 */
yext.scheduledupdates.dialog.Base = function(options) {
  this.$ctxt = options.container;
  this.options = options;
  this.getSubmitData = options.getSubmitData
    ? options.getSubmitData : function() {};

  if (this.$ctxt.length <= 0) {
    throw new Error('Dialog Context Not Found');
  }

  this.createDialog();
  this.bindActions();
};

/**
 * Create the Dialog from the given context
 * @suppress {deprecated}
 */
yext.scheduledupdates.dialog.Base.prototype.createDialog = function() {
  var closeFunction = function() {};
  if (this.options.unbindOnClose) {
    closeFunction = function(e) {
      var $dialog = $(e.target);
      $dialog.unbind();
    };
  }
  if (this.options.destroyOnClose) {
    closeFunction = function(e) {
      var $dialog = $(e.target);
      $dialog.dialog('destroy');
      $dialog.remove();
    };
  }

  var dialogOptions = {
    autoOpen: false,
    modal: true,
    draggable: false,
    resizable: false,
    minWidth: '330',
    open: function() {
      $(this).find('.view-scheduled-updates-date-wrap').first().blur();
    },
    close: closeFunction,
  };

  if (this.options.title) {
    dialogOptions.title = this.options.title;
  }

  this.$ctxt.dialog(dialogOptions);
};

/**
 * Show the dialog
 */
yext.scheduledupdates.dialog.Base.prototype.show = function() {
  this.$ctxt.dialog('open');
};

/**
 * Bind Dialog Actions
 */
yext.scheduledupdates.dialog.Base.prototype.bindActions = function() {
  var self = this;
  this.$ctxt.find('.js-cancel-btn').unbind().on('click', function() {
    self.$ctxt.dialog('close');
  });

  this.$ctxt.find('.js-submit-btn').unbind().on('click', function() {
    self.$ctxt.trigger('submit', self.getSubmitData());

    if (!self.options.keepOpenOnSubmit) {
      self.$ctxt.dialog('close');
    }
  });

  this.$ctxt.on('dialogclose', function() {
    self.$ctxt.trigger('close');
  });
};

/**
 * Creates and returns all of the anchors for the view scheduled updates dialogue
 */
var getAnchors = function(template, dates, isBulk) {
  var anchors = [];
  for (var i in dates) {
    var date = dates[i];
    var a = '' + template;
    var linkText = date.date;
    if (isBulk) {
      linkText += ' ' + yext.msgn('(1 entity)', '({0} entities)', date.entityCount);
    }
    a = a.replace('{{scheduledUpdateLinkText}}', linkText);
    a = a.replace('{{scheduledUpdateHref}}', date.href);
    anchors.push(a);
  }

  return anchors;
};

/**
 * Returns the properly i18ned text for the given count for view scheduled updates
 */
var getI18nViewText = function(count) {
  return yext.msgn(
    'This field has 1 scheduled update. Click below to preview this entity, reschedule, or cancel the update.',
    'This field has {0} scheduled updates. Click below to preview this entity, reschedule, or cancel the update.',
    count);
};
